export const DEFAULT_STATE = {
  currentCompany: null,
  timezones: [],
  phoneNumber: null,
  isRedirectedToHubspotWidget: false
}
